<template>
  <button
    type="button"
    class="inline-flex items-center justify-center"
    :class="[sizeClass, levelClass, clickableClass]"
    @click.stop="emit('click')"
  >
    {{ id }}
  </button>
</template>

<script setup lang="ts">
import { ScoreLevel } from '@/shared/graphql/router/graphql'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    id: string | number
    level?: ScoreLevel | null
    size?: 'default' | 'lg'
    clickable?: boolean
  }>(),
  { size: 'default', clickable: false }
)

const emit = defineEmits<{
  click: []
}>()

const sizeClass = computed(() =>
  props.size === 'lg'
    ? 'border border-white/75 rounded-md h-[26px] min-w-[20px] px-[7px] text-[14px] leading-[12px] font-primary font-medium text-gray-100 match-tag-shadow'
    : 'border border-white rounded-sm h-[18px] min-w-[16px] text-[11px] leading-[12px] font-medium font-secondary tracking-[-0.07] text-white'
)

const clickableClass = computed(() => ({
  'cursor-pointer': props.clickable,
}))

const levelClass = computed(() => ({
  'bg-gray-500': !props.level,
  'bg-red-500': props.level === ScoreLevel.High,
  'bg-yellow-500': props.level === ScoreLevel.Medium,
  'bg-green-500': props.level === ScoreLevel.Low,
}))
</script>

<style scoped>
.match-tag-shadow {
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.05),
    0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
</style>
